"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeySettingsEditionDataTags = exports.SankeySettingsEditionElementTags = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const prop_types_1 = __importDefault(require("prop-types"));
const SankeyUtils_1 = require("./SankeyUtils");
const types_1 = require("./types");
const fa_1 = require("react-icons/fa");
const SankeyUtils_2 = require("./SankeyUtils");
const colormap_1 = __importDefault(require("colormap"));
const SankeySettingsEditionTagsPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    elementTagNameProp: prop_types_1.default.oneOf(['nodeTags', 'fluxTags']).isRequired,
    elementNameProp: prop_types_1.default.oneOf(['nodes', 'links']).isRequired
};
const SankeySettingsEditionElementTags = ({ data, set_data, elementTagNameProp, elementNameProp }) => {
    const [tags_group_key, set_tags_group_key] = (0, react_1.useState)(Object.keys(data[elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags']).length > 0 ? Object.keys(data[elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags'])[0] : '');
    const colormaps = [
        'custom',
        'jet', 'hsv', 'hot', 'cool', 'spring', 'summer', 'autumn', 'winter', 'bone',
        'copper', 'greys', 'YIGnBu', 'greens', 'YIOrRd', 'bluered', 'RdBu', 'picnic',
        'rainbow', 'portland', 'blackbody', 'earth', 'electric',
        'viridis', 'inferno', 'magma', 'plasma', 'warm', 'cool', 'rainbow-soft',
        'bathymetry', 'cdom', 'chlorophyll', 'density', 'freesurface-blue', 'freesurface-red', 'oxygen', 'par', 'phase', 'salinity', 'temperature', 'turbidity', 'velocity-blue', 'velocity-green',
        'cubehelix'
    ];
    const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
    //Permet de modifier le type de bannier pour le groupTag (si ce non Aucun)
    const handleBanner = (tags_group_key, evt) => {
        data[elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags'][tags_group_key].banner = evt.target.value;
        set_data(Object.assign({}, data));
    };
    let element_tags = [];
    if (Object.keys(data[elementTagName]).length > 0 && tags_group_key !== '') {
        if (tags_group_key in data[elementTagName]) {
            element_tags = Object.keys(data[elementTagName][tags_group_key].tags);
        }
        else {
            console.log('tutu');
        }
    }
    // --------------------------------------------
    //ajoute un étiquette au groupe selectionné 
    const handleAddTagButton = () => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        // Méthode pour incrementer idElement
        const listId = [];
        Object.keys(data[elementTagName][tags_group_key].tags).forEach(elt => listId.push(Number(elt.replace('element', ''))));
        const idElement = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        data[elementTagName][tags_group_key].tags['element' + idElement] = { name: 'étiquette' + idElement, color: '#000000', selected: true };
        const nb_tags = Object.keys(data[elementTagName][tags_group_key].tags).length;
        const colors = (0, colormap_1.default)({
            colormap: data[elementTagName][tags_group_key].color_map,
            nshades: Math.max(11, nb_tags),
            format: 'hex',
            alpha: 1
        });
        let step = 1;
        if (nb_tags < 11) {
            step = Math.round(11 / nb_tags);
        }
        Object.keys(data[elementTagName][tags_group_key].tags).forEach((tag_key, i) => data[elementTagName][tags_group_key].tags[tag_key].color = colors[i * step]);
        if (elementTagName === 'nodeTags' && tags_group_key === 'Dimensions') {
            Object.values(data.nodes).forEach(node => node.dimensions['element' + idElement] = { parent_name: undefined, level: 1 });
        }
        set_data(Object.assign({}, data));
    };
    //Ajoute un groupTag
    const handleAddTagGrpButton = () => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        const elementName = elementNameProp === 'nodes' ? 'nodes' : 'links';
        // Méthode pour incrementer idGroup
        const listId = [];
        Object.keys(data[elementTagName]).forEach(elt => listId.push(Number(elt.replace('tag_group_', ''))));
        const idGroup = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        data[elementTagName]['tag_group_' + idGroup] = {
            group_name: 'Étiquette Group ' + idGroup,
            show_legend: false,
            color_map: 'jet',
            tags: {},
            banner: 'multi'
        };
        if (elementName === 'nodes') {
            Object.values(data[elementName]).forEach(n => n.tags['tag_group_' + idGroup] = []);
        }
        if (Object.keys(data[elementTagName]).length === 1) {
            Object.values(data[elementName]).forEach(n => n.colorTag = Object.keys(data[elementTagName])[0]);
        }
        set_tags_group_key('tag_group_' + idGroup);
        set_data(Object.assign({}, data));
    };
    const handleDelTag = (n) => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        const elementName = elementTagNameProp === 'nodeTags' ? 'nodes' : 'links';
        delete data[elementTagName][tags_group_key].tags[n];
        Object.values(data[elementName]).forEach(el => el.tags[tags_group_key] = el.tags[tags_group_key].filter((tag) => tag !== n));
        set_data(Object.assign({}, data));
    };
    const handleDelGroupTag = (tags_group_key) => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        const elementName = elementNameProp === 'nodes' ? 'nodes' : 'links';
        delete data[elementTagName][tags_group_key];
        Object.values(data[elementName]).forEach(n => {
            if (n.colorTag === tags_group_key) {
                n.colorTag = '';
            }
            delete n.tags[tags_group_key];
        });
        if (Object.keys(data[elementTagName]).length > 0) {
            const lastElmt = Object.keys(data[elementTagName])[Object.keys(data[elementTagName]).length - 1];
            set_tags_group_key(lastElmt);
        }
        set_data(Object.assign({}, data));
    };
    const handleUpGrpTag = (i) => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        const listElmt = Object.keys(data[elementTagName]);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt - 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = data[elementTagName][elt];
        });
        for (const member in data[elementTagName])
            delete data[elementTagName][member];
        Object.assign(data[elementTagName], new_cat);
        set_data(Object.assign({}, data));
    };
    const handleDownGrpTag = (i) => {
        const elementTagName = elementTagNameProp === 'nodeTags' ? 'nodeTags' : 'fluxTags';
        const listElmt = Object.keys(data[elementTagName]);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt + 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = data[elementTagName][elt];
        });
        for (const member in data[elementTagName])
            delete data[elementTagName][member];
        Object.assign(data[elementTagName], new_cat);
        set_data(Object.assign({}, data));
    };
    const tagSetting = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "Groupe d'\u00E9tiquettes:")),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                        set_tags_group_key(evt.target.value);
                        set_data(Object.assign({}, data));
                    } }, Object.keys(data[elementTagName]).map((key, i) => react_1.default.createElement("option", { key: i, value: key, selected: tags_group_key === key }, data[elementTagName][key].group_name)))),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                        data[elementTagName][tags_group_key].color_map = evt.target.value;
                        const nb_tags = Object.keys(data[elementTagName][tags_group_key].tags).length;
                        if (evt.target.value === 'custom') {
                            return;
                        }
                        const colors = (0, colormap_1.default)({
                            colormap: evt.target.value,
                            nshades: Math.max(11, nb_tags),
                            format: 'hex',
                            alpha: 1
                        });
                        let step = 1;
                        if (nb_tags < 11) {
                            step = Math.round(11 / nb_tags);
                        }
                        Object.keys(data[elementTagName][tags_group_key].tags).forEach((tag_key, i) => data[elementTagName][tags_group_key].tags[tag_key].color = colors[i * step]);
                        set_data(Object.assign({}, data));
                    } }, colormaps.map((cur_colormap, i) => react_1.default.createElement("option", { key: i, value: cur_colormap, selected: data[elementTagName][tags_group_key] && data[elementTagName][tags_group_key].color_map === cur_colormap }, cur_colormap))))),
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: 'sm', size: 'sm', className: 'node_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", value: '+', onClick: handleAddTagButton },
                            react_1.default.createElement(fa_1.FaPlus, null)),
                        " "),
                    react_1.default.createElement("th", null, "Nom"),
                    react_1.default.createElement("th", null, "Visible"),
                    react_1.default.createElement("th", null, "Couleur"),
                    elementNameProp === 'nodes' ? (react_1.default.createElement("th", null, "Forme")) : (react_1.default.createElement(react_1.default.Fragment, null)))),
            react_1.default.createElement("tbody", null, element_tags.length > 0 ? element_tags.map((tag_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", value: '-', onClick: () => { handleDelTag(tag_key); } },
                            react_1.default.createElement(fa_1.FaMinus, null))),
                    react_1.default.createElement("td", { style: { 'width': '33%' } },
                        react_1.default.createElement(react_bootstrap_1.FormControl /* size='sm' */, { id: i.toString(), type: "text", value: data[elementTagName][tags_group_key].tags[tag_key].name, onChange: (evt) => {
                                const new_nb_element = evt.target;
                                const name = new_nb_element.value;
                                data[elementTagName][tags_group_key].tags[tag_key].name = name;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, name: 'element_visible' + tag_key, checked: data[elementTagName][tags_group_key].tags[tag_key].selected, id: tag_key, type: 'switch', onChange: (evt) => {
                                const new_nb_element = evt.target;
                                const tag_key = new_nb_element.id;
                                const visible = new_nb_element.checked;
                                data[elementTagName][tags_group_key].tags[tag_key].selected = visible;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "color", value: data[elementTagName][tags_group_key].tags[tag_key].color, onChange: evt => {
                                data[elementTagName][tags_group_key].tags[tag_key].color = evt.target.value;
                                set_data(Object.assign({}, data));
                            } })),
                    elementNameProp === 'nodes' ? (react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                            data[elementTagName][tags_group_key].tags[tag_key].shape = evt.target.value;
                            set_data(Object.assign({}, data));
                        }, value: data[elementTagName][tags_group_key].tags[tag_key].shape },
                        react_1.default.createElement("option", { key: 'rect' + i, id: 'rect', value: 'rect' }, "Rectangle"),
                        react_1.default.createElement("option", { key: 'circle' + i, id: 'circle', value: 'ellipse' }, "Circle"))) : (react_1.default.createElement(react_1.default.Fragment, null))));
            }) : (react_1.default.createElement(react_1.default.Fragment, null))))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, className: 'node_group_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: handleAddTagGrpButton },
                            react_1.default.createElement(fa_1.FaPlus, null))),
                    react_1.default.createElement("th", null, "Nom"),
                    react_1.default.createElement("th", null, "L\u00E9gende"),
                    react_1.default.createElement("th", null, "\u00C9tiquette"),
                    react_1.default.createElement("th", null, "Banni\u00E8re"),
                    react_1.default.createElement("th", null, "Position"))),
            react_1.default.createElement("tbody", null, Object.keys(data[elementTagName]).map((tags_group_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: () => handleDelGroupTag(tags_group_key) },
                            react_1.default.createElement(fa_1.FaMinus, null))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { id: i.toString(), type: "text", value: data[elementTagName][tags_group_key].group_name, onChange: (evt) => {
                                const new_name = evt.target.value;
                                data[elementTagName][tags_group_key].group_name = new_name;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, 
                            // Permet de selection le étiquette pour l'affichage dans la légende
                            name: 'element_legend_' + tags_group_key, checked: data[elementTagName][tags_group_key].show_legend, id: tags_group_key, type: 'switch', onChange: (evt) => {
                                const new_nb_element = evt.target;
                                const tags_group_key = new_nb_element.id;
                                const visible = new_nb_element.checked;
                                data[elementTagName][tags_group_key].show_legend = visible;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", null, Object.keys(data[elementTagName][tags_group_key].tags).length),
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => handleBanner(tags_group_key, evt) },
                        react_1.default.createElement("option", { key: 'none' + i, id: 'NoneBaner', selected: data[elementTagName][tags_group_key].banner === 'none' || !data[elementTagName][tags_group_key].banner, value: 'none' }, "Aucun"),
                        react_1.default.createElement("option", { key: 'one' + i, id: 'OneBaner', selected: data[elementTagName][tags_group_key].banner === 'one', value: 'one' }, "Unique"),
                        react_1.default.createElement("option", { key: 'multi' + i, id: 'MultipleBaner', selected: data[elementTagName][tags_group_key].banner === 'multi', value: 'multi' }, "Multiple")),
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: "button_position", size: "sm" },
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleUpGrpTag(tags_group_key) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleUp, null)),
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: "info", onClick: () => handleDownGrpTag(tags_group_key) },
                                react_1.default.createElement(fa_1.FaArrowAltCircleDown, null))))));
            }))),
        Object.keys(data[elementTagName]).length > 0 ? tagSetting : react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.SankeySettingsEditionElementTags = SankeySettingsEditionElementTags;
const SankeySettingsDataTagsPropTypes = {
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
};
const SankeySettingsEditionDataTags = ({ data, set_data }) => {
    const [data_tags_group_key, set_data_tags_group_key] = (0, react_1.useState)(Object.keys(data.dataTags).length > 0 ? Object.keys(data.dataTags)[0] : '');
    const { links, dataTags } = data;
    let max_link_value = 0;
    Object.values(links).forEach(link => {
        const new_max_link_value = (0, SankeyUtils_1.findMaxLinkValue)(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    // --------------------------------------------
    //ajoute un étiquette au group selectionné 
    const handleAddTagButton = () => {
        const { dataTags } = data;
        //Si le DataTag n'a pas de étiquette alors le premier crée sera selectionné par defaut
        const selectedDefault = (Object.keys(dataTags[data_tags_group_key].tags).length == 0) ? true : false;
        //création d'un étiquette par defaut
        // Méthode pour incrementer idElement
        const listId = [];
        Object.keys(dataTags[data_tags_group_key].tags).forEach(elt => listId.push(Number(elt.replace('element', ''))));
        const idElement = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        dataTags[data_tags_group_key].tags['element' + idElement] = { name: 'étiquette' + idElement, color: '#000000', selected: selectedDefault };
        const dataTagsArray = Object.values(dataTags).filter(dataTag => { return (Object.keys(dataTag.tags).length != 0) ? true : false; });
        Object.values(data.links).forEach(l => {
            (0, SankeyUtils_2.addDataTags)(dataTagsArray, l.value, 0);
        });
        set_data(Object.assign({}, data));
    };
    //Ajoute un groupTag
    const handleAddTagGrpButton = () => {
        const { dataTags } = data;
        // Méthode pour incrementer idGroup
        const listId = [];
        Object.keys(dataTags).forEach(elt => listId.push(Number(elt.replace('tag_group_', ''))));
        const idGroup = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        dataTags['tag_group_' + idGroup] = {
            group_name: 'Étiquette Group ' + idGroup,
            show_legend: false,
            color_map: 'jet',
            tags: {},
            banner: 'multi'
        };
        set_data_tags_group_key('tag_group_' + idGroup);
        set_data(Object.assign({}, data));
    };
    //supprime étiquette
    const handleDelTag = (n) => {
        const { dataTags } = data;
        delete dataTags[data_tags_group_key].tags[n];
        set_data(Object.assign({}, data));
    };
    //supprime groupTag
    const handleDelGroupTag = (tags_group_key) => {
        const { dataTags } = data;
        delete dataTags[tags_group_key];
        if (Object.keys(dataTags).length > 0) {
            const lastElmt = Object.keys(dataTags)[Object.keys(dataTags).length - 1];
            set_data_tags_group_key(lastElmt);
        }
        set_data(Object.assign({}, data));
    };
    const tagSetting = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, "TagGroupe:")),
            react_1.default.createElement(react_bootstrap_1.Col, null,
                react_1.default.createElement(react_bootstrap_1.Form.Select, { onChange: (evt) => {
                        set_data_tags_group_key(evt.target.value);
                        set_data(Object.assign({}, data));
                    } }, Object.keys(dataTags).map((key, i) => react_1.default.createElement("option", { key: i, value: key, selected: data_tags_group_key === key }, dataTags[key].group_name))))),
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true, responsive: 'sm', size: 'sm', className: 'link_tags_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", value: '+', onClick: handleAddTagButton },
                            react_1.default.createElement(fa_1.FaPlus, null))),
                    react_1.default.createElement("th", null, "Nom"),
                    react_1.default.createElement("th", null, "S\u00E9lectionn\u00E9"))),
            react_1.default.createElement("tbody", null, Object.keys(dataTags).length > 0 && data_tags_group_key !== '' ? Object.keys(dataTags[data_tags_group_key].tags).map((tag_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: () => { handleDelTag(tag_key); } },
                            react_1.default.createElement(fa_1.FaMinus, null))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', id: i.toString(), type: "text", value: dataTags[data_tags_group_key].tags[tag_key].name, onChange: (evt) => {
                                const { dataTags } = data;
                                const new_nb_element = evt.target;
                                const name = new_nb_element.value;
                                for (const l in data.links) {
                                    data.links[l].value = JSON.parse(JSON.stringify(data.links[l].value).replaceAll('"' + dataTags[data_tags_group_key].tags[tag_key].name + '"', '"' + name + '"'));
                                }
                                dataTags[data_tags_group_key].tags[tag_key].name = name;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, name: 'element_selected' + tag_key, checked: dataTags[data_tags_group_key].tags[tag_key].selected, id: tag_key, type: 'switch', onChange: (evt) => {
                                const new_nb_element = evt.target;
                                const tag_key = new_nb_element.id;
                                const visible = new_nb_element.checked;
                                Object.values(dataTags[data_tags_group_key].tags).map(d => {
                                    d.selected = false;
                                });
                                dataTags[data_tags_group_key].tags[tag_key].selected = visible;
                                set_data(Object.assign({}, data));
                            } }))));
            }) : (react_1.default.createElement(react_1.default.Fragment, null))))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, responsive: 'sm', size: 'sm', hover: true, className: 'data_group_tag_definition' },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null,
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "success", onClick: handleAddTagGrpButton },
                            react_1.default.createElement(fa_1.FaPlus, null))),
                    react_1.default.createElement("th", null, "Nom"),
                    react_1.default.createElement("th", null, "\u00C9tiquette"))),
            react_1.default.createElement("tbody", null, Object.keys(dataTags).map((data_tags_group_key, i) => {
                return (react_1.default.createElement("tr", { key: i.toString() },
                    react_1.default.createElement("td", { style: { 'width': '10%' } },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "danger", onClick: () => handleDelGroupTag(data_tags_group_key) },
                            react_1.default.createElement(fa_1.FaMinus, null))),
                    react_1.default.createElement("td", null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { id: i.toString(), type: "text", value: dataTags[data_tags_group_key].group_name, onChange: (evt) => {
                                const { dataTags } = data;
                                const new_name = evt.target.value;
                                dataTags[data_tags_group_key].group_name = new_name;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement("td", null, Object.keys(dataTags[data_tags_group_key].tags).length)));
            }))),
        Object.keys(dataTags).length > 0 ? tagSetting : react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.SankeySettingsEditionDataTags = SankeySettingsEditionDataTags;
SankeySettingsEditionElementTags.propTypes = SankeySettingsEditionTagsPropTypes;
SankeySettingsEditionDataTags.propTypes = SankeySettingsDataTagsPropTypes;
exports.default = null;
